import { defineMessages } from "react-intl";

const baseId = "t.components.modals.exitModal.";

export default defineMessages({
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: baseId + "cancel",
    defaultMessage: "Cancel",
  },
  title: {
    id: baseId + "title",
    defaultMessage: "Confirm?",
  },
  content: {
    id: baseId + "content",
    defaultMessage: "Are you sure to exit?",
  },
});
